export default __webpack_public_path__ + "static/media/search-grey.6145272a.svg";